angular.module("Main").factory("AuthenticationService", ["$rootScope", "$http", "$base64", "$cookies", "$translate", "$localStorage", "NODEBACKEND", "SessionService",
    function ($rootScope, $http, $base64, $cookies, $translate, $localStorage, NODEBACKEND, SessionService) {
        return {
            login: login,
            checkPassword: checkPassword,
            getNewPassword: getNewPassword,
            changePassword: changePassword,
            sendForgotPasswordMail: sendForgotPasswordMail,
            authenticate: authenticate,
            isCenterCom: isCenterCom,
            checkVersion: checkVersion
        };

        function login(email, password) {
            var data = {email: email, password: password};
            $localStorage.user = {};

            return $http.post(NODEBACKEND + "/booking/check/login", data).then(function (response) {
                if (response.status === 204) { // login failed
                    SessionService.clear("globals");
                    return null;
                }
                SessionService.setUserData(response.data);
                $localStorage.user.username = response.data.Firstname + " " + response.data.Lastname;
                $localStorage.user.Firstname = response.data.Firstname;
                $localStorage.user.Lastname = response.data.Lastname;
                $localStorage.user.isMember = response.data.IsMember;
                $localStorage.user.memberNr = response.data.MemberNr;
                $localStorage.user.Email = response.data.Email;
                $localStorage.user.uid = response.data.uid;
                $localStorage.user.isPayPal = response.data.IsPaypal;
                $localStorage.user.isBonitaet = response.data.IsBonitaet;

                return response.data;
            });
        }

        function checkPassword(email, password) {
            var data = {email: email, password: password};
            return $http.post(NODEBACKEND + "/booking/check/login", data).then(function (response) {
                if (response.status === 204)
                    return null;
                else
                    return response.data;
            })
        }

        function getNewPassword(guid) {
            return $http.post(NODEBACKEND + "/booking/password/shortregistration/" + guid, null).then(function (response) {
                return response.data;
            })
        }

        function changePassword(guid, changedPassword) {
            var data = {MemberNr: guid, Password: changedPassword};
            return $http.put(NODEBACKEND + "/booking/password", data);
        }

        function sendForgotPasswordMail(guid, password) {
            return $translate(["T_Neues_Kennwort", "LT_EMAIL_NEW_PASSWORD_TEXT"], {password: password}).then(function (translation) {
                var mail = {
                    subject: translation.T_Neues_Kennwort,
                    content: "<p>" + translation.LT_EMAIL_NEW_PASSWORD_TEXT + "</p>"
                };
                return $http.post(NODEBACKEND + "/communication/email/" + guid, mail);
            });
        }

        function authenticate(referrer) {
            return $http.post(NODEBACKEND + "/booking/authenticate", {ref: referrer});
        }

        function isCenterCom() {
            return $http.get(NODEBACKEND + "/onlinebooking/isCenterCom").then(function (response) {
                return response.data;
            })
        }

        function checkVersion(route, tenant) {
            return $http.post(NODEBACKEND + "/booking/checkVersion", {route: route, tenant: tenant})
                .then(function (response) {
                    return response.data;
                })
        }
    }]);